import type { OutreachPitchKind } from 'fym-shared/src/music24/outreach/dailyPitches';
import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';

/** `outreach.campaigns.poolSummary` (music24-api `CampaignPoolSummary`). */
export interface CampaignPool {
  byKind: Record<OutreachPitchKind, number>;
  total: number;
  /** Of `byKind`: the people that the find added in the last 24 hours ("Found last night", design g1). */
  newByKind: Record<OutreachPitchKind, number>;
  newTotal: number;
}

/** The people that fit the campaign now, by kind (design outreach-v2 c1 "fit now"). */
export function useCampaignPool(accountId: number, campaignUuid: string) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.campaigns.poolSummary.queryOptions({ accountId, campaignUuid }, { retry: false })
  );
  return { pool: (query.data as CampaignPool | null | undefined) ?? null, isLoading: query.isLoading };
}
